import { createResourceCollection } from '@/request'
import { ThermostatSavingsSummary } from '@/types'
import { addThermostatIdFromPath } from './collectionMiddleware'

export const thermostatSavingsSummariesCollection =
  createResourceCollection<ThermostatSavingsSummary>({
    name: 'thermostatSavingsSummaries',
    selector: (state) => state.thermostatSavingsSummaries,
    apiConfig: {
      middlewares: [addThermostatIdFromPath<ThermostatSavingsSummary>()],
    },
  })

export const thermostatSavingsSummaries =
  thermostatSavingsSummariesCollection.slice.reducer
